"use strict";
var list = document.querySelector(".gallery__list");
var largeImg = document.querySelector(".gallery__large-img");
list.addEventListener("click", function(e) {
    var link = e.target.closest(".list-item__link");
    if (!link) return;
    var imgSrcNew = link.getAttribute("href");
    e.preventDefault();
    largeImg.setAttribute("src", imgSrcNew);
});

//# sourceMappingURL=index.f5ab85a1.js.map
